// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Config from "../../../../Config.bs.js";
import * as CrmUserRepo from "./CrmUserRepo.bs.js";
import * as DummyCrmUserRepo from "./DummyCrmUserRepo.bs.js";

function getCrmUserRepo(param) {
  var match = Config.Env.env;
  if (match === "development") {
    return DummyCrmUserRepo.T;
  } else {
    return CrmUserRepo.T;
  }
}

export {
  getCrmUserRepo ,
  
}
/* Config Not a pure module */
